import { render, staticRenderFns } from "./ActionNotification.vue?vue&type=template&id=00bb37d6&scoped=true&"
import script from "./ActionNotification.vue?vue&type=script&lang=js&"
export * from "./ActionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb37d6",
  null
  
)

export default component.exports